import { getFuturaAttributeIcon } from 'utils/futura';
import { CollectionFilterItem, CollectionAttributes } from 'utils/types';
import CollectionFilterAccordion from './CollectionFilterAccordion';
import CollectionFilterOptions from './CollectionFilterOptions';
import { Box, Flex } from './ui';

interface CollectionFilterProps {
  item: CollectionFilterItem;
  handleCheck: (name: string, checked: string[]) => void;
  checked: string[];
}

/**
 * Renders either a flat level filter item or a hierarchical one.
 * Choice is made based on the attributes associated with the filter item.
 */
const CollectionFilter = ({ item, handleCheck, checked }: CollectionFilterProps) => {
  const mapAttributeName = (name: string): string => (name === 'Bpm' ? 'Tempo' : name);

  // Helpers that will decide if we render a flat hierarchy or regular hierarchy for a collection filter.
  const shouldRenderFlatHierarchy = item.attributes && item.attributes.length === 1;
  const shouldRenderHierarchy = item.attributes && item.attributes.length > 1;

  return (
    <CollectionFilterAccordion key={item.name} title={mapAttributeName(item.name)}>
      {shouldRenderFlatHierarchy && (
        <CollectionFilterOptions
          checked={checked}
          handleCheck={handleCheck}
          attribute={item.attributes[0]}
        ></CollectionFilterOptions>
      )}
      {shouldRenderHierarchy && (
        <Flex width="100%" flexDirection="column" paddingLeft="15px" background="#111">
          {item.attributes.map((attribute: CollectionAttributes) => (
            <Box width="100%" height="100%" borderLeft={'1px solid #333'} key={attribute.name}>
              <CollectionFilterAccordion
                key={attribute.name}
                title={mapAttributeName(attribute.name)}
                iconSrc={getFuturaAttributeIcon(attribute.name)}
              >
                <CollectionFilterOptions
                  checked={checked}
                  handleCheck={handleCheck}
                  attribute={attribute}
                ></CollectionFilterOptions>
              </CollectionFilterAccordion>
            </Box>
          ))}
        </Flex>
      )}
    </CollectionFilterAccordion>
  );
};

export default CollectionFilter;
